const initializeLandingMenus = () => {
  document.querySelectorAll('.header').forEach((header) => {
    if (header.dataset.menuInitialized) return

    const toggle = header.querySelector('.js-menu-toggle')
    const closeButtons = header.querySelectorAll('.js-menu-close, .header__nav a')

    if (!toggle) return

    const setMenuOpen = (isOpen) => {
      header.classList.toggle('header--menu-opened', isOpen)
      document.body.classList.toggle('landing-menu-opened', isOpen)
    }

    toggle.addEventListener('click', () => {
      setMenuOpen(!header.classList.contains('header--menu-opened'))
    })

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => setMenuOpen(false))
    })

    header.dataset.menuInitialized = 'true'
  })
}

const initializeTestimonials = () => {
  document.querySelectorAll('.testimonials-slider, .business-testimonials').forEach((slider) => {
    if (slider.dataset.carouselInitialized) return

    const items = Array.from(slider.querySelectorAll('.testimonials-slick__item'))
    const previousButton = slider.querySelector('.testimonials-slick__prev-arrow')
    const nextButton = slider.querySelector('.testimonials-slick__next-arrow')

    if (items.length === 0 || !previousButton || !nextButton) return

    let activeIndex = 0

    const showTestimonial = (index) => {
      activeIndex = Math.max(0, Math.min(index, items.length - 1))

      items.forEach((item, itemIndex) => {
        const isActive = itemIndex === activeIndex
        item.classList.toggle('is-active', isActive)
        item.hidden = !isActive
      })

      previousButton.disabled = activeIndex === 0
      nextButton.disabled = activeIndex === items.length - 1
    }

    previousButton.addEventListener('click', () => showTestimonial(activeIndex - 1))
    nextButton.addEventListener('click', () => showTestimonial(activeIndex + 1))
    showTestimonial(activeIndex)
    slider.dataset.carouselInitialized = 'true'
  })
}

const initializeBusinessHeroSliders = () => {
  document.querySelectorAll('.business-hero').forEach((hero) => {
    if (hero.dataset.sliderInitialized) return

    const radios = Array.from(hero.querySelectorAll('.business-hero__radio'))
    const sequence = [0, 1, 2, 1]

    if (radios.length !== 3) return

    let sequenceIndex = 0
    let interval

    const showSlide = (index) => {
      radios[index].checked = true
    }

    const startAutoplay = () => {
      clearInterval(interval)
      interval = setInterval(() => {
        sequenceIndex = (sequenceIndex + 1) % sequence.length
        showSlide(sequence[sequenceIndex])
      }, 4000)
    }

    radios.forEach((radio, index) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return

        sequenceIndex = sequence.indexOf(index)
        startAutoplay()
      })
    })

    showSlide(sequence[sequenceIndex])
    startAutoplay()
    hero.dataset.sliderInitialized = 'true'
  })
}

const initializeAccordions = () => {
  document.querySelectorAll('.accordion-section').forEach((section) => {
    if (section.dataset.accordionInitialized) return

    section.querySelectorAll('.accordion-section__open').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const content = trigger.nextElementSibling
        const isOpen = trigger.classList.contains('accordion-section__open--active')

        section.querySelectorAll('.accordion-section__open').forEach((item) => {
          item.classList.remove('accordion-section__open--active')
          if (item.nextElementSibling) item.nextElementSibling.style.display = 'none'
        })

        if (!isOpen) {
          trigger.classList.add('accordion-section__open--active')
          content.style.display = 'block'
        }
      })
    })

    section.dataset.accordionInitialized = 'true'
  })
}

const initializeInjuryDropdowns = () => {
  document.querySelectorAll('.js-injury-dropdown').forEach((dropdown) => {
    if (dropdown.dataset.dropdownInitialized) return

    const toggle = dropdown.querySelector('.js-injury-dropdown-toggle')
    const select = dropdown.querySelector('.js-injury-dropdown-select')

    if (!toggle || !select) return

    const closeDropdown = () => {
      toggle.classList.remove('dropdown-menu__link--active')
      select.style.display = 'none'
    }

    toggle.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()

      const isOpen = toggle.classList.contains('dropdown-menu__link--active')
      document.querySelectorAll('.js-injury-dropdown-toggle').forEach((item) => {
        item.classList.remove('dropdown-menu__link--active')
      })
      document.querySelectorAll('.js-injury-dropdown-select').forEach((item) => {
        item.style.display = 'none'
      })

      if (!isOpen) {
        toggle.classList.add('dropdown-menu__link--active')
        select.style.display = 'block'
      }
    })

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.js-injury-dropdown')) closeDropdown()
    })

    dropdown.dataset.dropdownInitialized = 'true'
  })
}

const initializeContactModal = () => {
  const modal = document.querySelector('.js-contact-modal')
  if (!modal || modal.dataset.initialized) return

  const modalItem = modal.querySelector('#modal-request-form')
  const form = modal.querySelector('.js-contact-form')
  const status = modal.querySelector('.js-contact-form-status')
  const submitButton = modal.querySelector('.js-contact-form-submit')
  const fieldNodes = Array.from(modal.querySelectorAll('.js-contact-field'))

  const csrfToken = () => {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute('content') : ''
  }

  const showStatus = (message, type) => {
    if (!status) return

    status.hidden = false
    status.textContent = message
    status.classList.remove('modal-request-form__status--success', 'modal-request-form__status--error')
    status.classList.add(`modal-request-form__status--${type}`)
  }

  const clearStatus = () => {
    if (!status) return

    status.hidden = true
    status.textContent = ''
    status.classList.remove('modal-request-form__status--success', 'modal-request-form__status--error')
  }

  const clearFieldErrors = () => {
    fieldNodes.forEach((field) => {
      field.classList.remove('field--invalid')
      const error = field.querySelector('.js-contact-field-error')
      if (!error) return
      error.hidden = true
      error.textContent = ''
    })
  }

  const showFieldErrors = (errors = {}) => {
    clearFieldErrors()

    Object.keys(errors).forEach((fieldName) => {
      const field = fieldNodes.find((node) => node.dataset.field === fieldName)
      if (!field) return

      const messages = errors[fieldName]
      const message = Array.isArray(messages) ? messages[0] : messages
      if (!message) return

      field.classList.add('field--invalid')
      const error = field.querySelector('.js-contact-field-error')
      if (!error) return
      error.hidden = false
      error.textContent = message
    })
  }

  const validateClientSide = () => {
    const errors = {}
    const nameInput = form.querySelector('[name="contact_message[name]"]')
    const emailInput = form.querySelector('[name="contact_message[email]"]')
    const messageInput = form.querySelector('[name="contact_message[message]"]')
    const emailValue = (emailInput?.value || '').trim()

    if (!(nameInput?.value || '').trim()) errors.name = ['Please enter your name']
    if (!emailValue) {
      errors.email = ['Please enter your email']
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
      errors.email = ['Please enter a valid email']
    }
    if (!(messageInput?.value || '').trim()) errors.message = ['Please enter your message']

    return errors
  }

  const openModal = (event) => {
    if (event) event.preventDefault()

    modal.hidden = false
    modal.classList.add('modal-window--active')
    if (modalItem) modalItem.classList.add('modal-window__item--active')
    document.body.classList.add('contact-modal-open')

    document.querySelectorAll('.header--menu-opened').forEach((header) => {
      header.classList.remove('header--menu-opened')
    })
    document.body.classList.remove('landing-menu-opened')
  }

  const closeModal = () => {
    modal.classList.remove('modal-window--active')
    if (modalItem) modalItem.classList.remove('modal-window__item--active')
    document.body.classList.remove('contact-modal-open')
    modal.hidden = true
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.request__demo, [href="#modal-request-form"]')
    if (trigger) openModal(event)
  })

  modal.querySelectorAll('.js-contact-modal-close').forEach((element) => {
    element.addEventListener('click', closeModal)
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal()
  })

  if (form) {
    form.querySelectorAll('input, textarea').forEach((input) => {
      input.addEventListener('input', () => {
        const field = input.closest('.js-contact-field')
        if (!field) return
        field.classList.remove('field--invalid')
        const error = field.querySelector('.js-contact-field-error')
        if (!error) return
        error.hidden = true
        error.textContent = ''
      })
    })

    form.addEventListener('submit', async (event) => {
      event.preventDefault()
      clearStatus()
      clearFieldErrors()

      const clientErrors = validateClientSide()
      if (Object.keys(clientErrors).length > 0) {
        showFieldErrors(clientErrors)
        showStatus('Please check the highlighted fields.', 'error')
        return
      }

      if (submitButton) {
        submitButton.disabled = true
        submitButton.textContent = 'Sending...'
      }

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-CSRF-Token': csrfToken(),
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: new FormData(form),
          credentials: 'same-origin',
        })

        const data = await response.json().catch(() => ({}))

        if (response.ok && data.success) {
          form.reset()
          clearFieldErrors()
          showStatus('Thanks! Your message has been sent.', 'success')
        } else if (data.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
          showFieldErrors(data.errors)
          showStatus(data.message || 'Please check the highlighted fields.', 'error')
        } else {
          showStatus('Something went wrong. Please try again.', 'error')
        }
      } catch (error) {
        showStatus('Something went wrong. Please try again.', 'error')
      } finally {
        if (submitButton) {
          submitButton.disabled = false
          submitButton.textContent = 'Send'
        }
      }
    })
  }

  modal.dataset.initialized = 'true'
}

const initializeLandingPage = () => {
  initializeLandingMenus()
  initializeTestimonials()
  initializeBusinessHeroSliders()
  initializeAccordions()
  initializeInjuryDropdowns()
  initializeContactModal()
}

document.addEventListener('DOMContentLoaded', initializeLandingPage)
document.addEventListener('turbolinks:load', initializeLandingPage)
